import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const Tenant = 'Tenant-Token'
const ExpiresInKey = 'Admin-Expires-In'
const Costumer = 'COSTOMER'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}



export function getCoustomer() {
  return Cookies.get(Costumer)
}

export function setCoustomer(token) {
  return Cookies.set(Costumer, token)
}

//是否是租户
export function setTenant(token) {
  return Cookies.set(Tenant, token)
}
export function getTenant() {
  return Cookies.get(Tenant)
}

export function removeToken() {

  Cookies.remove(Tenant)
  return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}


